export const RedirectTypes = {
  Default: 'Default',
  Deepview: 'Deepview',
  WebUrl: 'WebUrl',
  Any: 'Any',
};
